import EventsView from './EventsView';

export default EventsView;
